module.exports = __webpack_public_path__ + "img/twitter.fef946b8.png";